module.exports = __webpack_public_path__ + "static/media/kidneys.a82a84e6.svg";